	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.math.GLM;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-math/ref/GLM.js
// module id = 28
// module chunks = 0